import clsx from 'clsx'
import React, { forwardRef, ReactNode } from 'react'
import { TSizeAll } from 'src/types'
import styles from './FormComponentWrapperUI.module.scss'

export interface FormComponentWrapperUIProps {
  isError?: string | boolean
  children: ReactNode
  size: TSizeAll
  /**
   * If `true`, the whole component will have disabled styles
   */
  disabled?: boolean
  /**
   * Pass `style` from parent component
   */
  style?: React.CSSProperties
  /**
   * Pass `className` from parent component
   */
  className?: string
}

export const FormComponentWrapperUI = forwardRef<HTMLDivElement, FormComponentWrapperUIProps>(
  ({ children, size, disabled, className, isError, ...props }, ref) => (
    <div
      className={clsx(
        styles.wrapper,
        styles[size],
        {
          [styles.error]: isError,
          [styles.disabled]: disabled,
        },
        className,
        'form-component-wrapper',
      )}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  ),
)
